import { environment } from 'src/environments/environment';

const deployLinkTemplate = 'https://%authKey%.soului.%deploymentSubdomain%.%sessionServer%/';
const signedDeployLinkTemplate = `${deployLinkTemplate}?sig=%token%`;

export function generateDeployLink(
  keyName: string,
  deploymentSubdomain: string,
  token: string = null,
): string {
  const template = token ? signedDeployLinkTemplate : deployLinkTemplate;
  const authKey = keyName.replace(/^sm-/, '');
  const link = template
    .replace('%authKey%', authKey)
    .replace('%deploymentSubdomain%', deploymentSubdomain)
    .replace('%sessionServer%', environment.sessionServer)
    .replace('%token%', token);

  return link;
}
